// @flow

import * as React from "react"
import {toDinero} from "../util"

type Props = {
  className: string,
  name: string,
  onChange: (string, string) => void,
  value: string,
}

type State = {
  hasFocus: boolean,
  value: string,
}

export default class extends React.Component<Props, State> {
  static defaultProps = {
    className: "",
    onChange: () => {},
  }

  input: HTMLInputElement | null
  handleFocus: () => void
  handleBlur: () => void
  handleChange: (SyntheticInputEvent<HTMLInputElement>) => void
  handleKeyPress: (SyntheticKeyboardEvent<HTMLInputElement>) => void
  handlePaste: (SyntheticClipboardEvent<HTMLInputElement>) => void

  constructor(props: Props) {
    super(props)

    this.state = {
      hasFocus: false,
      value: toDinero(props.value).toFormat("0.00"),
    }
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handlePaste = this.handlePaste.bind(this)
  }

  handleFocus() {
    this.setState({hasFocus: true})
  }

  handleBlur() {
    this.setState({hasFocus: false}, () => {
      this.props.onChange(
        this.props.name,
        String(Math.trunc(smartParseFloat(this.state.value) * 100))
      )
    })
  }

  handlePaste(e: SyntheticClipboardEvent<HTMLInputElement>) {
    let pastedText = ""
    if (window.clipboardData && window.clipboardData.getData) {
      // IE
      pastedText = window.clipboardData.getData("Text")
    } else if (e.clipboardData && e.clipboardData.getData) {
      pastedText = e.clipboardData.getData("text/plain")
    }
    const parsed = parseInt(smartParseFloat(pastedText) * 100)
    if (isNaN(parsed)) {
      e.preventDefault()
      console.log("invalid paste, no paste!")
    }
    return false
  }

  handleKeyPress(e: SyntheticKeyboardEvent<HTMLInputElement>) {
    const input = e.currentTarget
    const regex = /^[0-9,\-]/
    const valid =
      e.metaKey || // cmd/ctrl
      e.which <= 0 || // arrow keys
      e.which == 8 || // delete / backspace key
      regex.test(String.fromCharCode(e.which))
    if (!valid) {
      e.preventDefault()
    }

    // dash (minus)
    if (e.key == "-") {
      if (input.value.indexOf("-") > -1) {
        return e.preventDefault()
      }
      if (input.value.length > 0 && input.selectionStart != 0) {
        return e.preventDefault()
      }
    }

    // comma
    if (e.key == ",") {
      if (input.value.indexOf(",") > -1) {
        return e.preventDefault()
      }
      if (input.selectionStart == 0) {
        return e.preventDefault()
      }
    }
  }

  handleChange(e: SyntheticInputEvent<HTMLInputElement>) {
    this.setState({value: e.currentTarget.value})
  }

  render() {
    const {className, ...otherProps} = this.props
    const {hasFocus, value} = this.state
    const newClassName = className + (hasFocus ? " has-focus" : "")
    return (
      <input
        {...otherProps}
        ref={(input) => (this.input = input)}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        value={value}
        onPaste={this.handlePaste}
        className={newClassName}
        onChange={this.handleChange}
        onKeyPress={this.handleKeyPress}
      />
    )
  }
}

const smartParseFloat = (value: string): number => {
  if (value == "") {
    value = "0"
  }
  value = value.toString()
  return parseFloat(value.replace(",", "."))
}
